// types
import { ButtonProps, ButtonType } from './types';

// components
import Button from './button';

export default function ButtonPseudo({
  className = '',
  text = '',
  disabled,
  icon,
  type = ButtonType.BUTTON,
  size,
  onClick,
  bold,
  onMouseEnter,
  tabIndex,
  iconPosition,
}: ButtonProps): React.JSX.Element {
  return (
    <Button
      className={`${className} button-pseudo`}
      text={text}
      size={size}
      disabled={disabled}
      icon={icon}
      type={type}
      onClick={onClick}
      bold={bold}
      onMouseEnter={onMouseEnter}
      tabIndex={tabIndex}
      iconPosition={iconPosition}
    />
  );
}
